<template>
  <ErrorPageBase :statusCode="400">
    不正なリクエストです。お使いのブラウザの履歴やCookieクリアをお試しください。<br />
    ご不明の点は、運営まで<ExternalLink :href="contactUrl" :class="$style.link"
      >お問い合わせ</ExternalLink
    >下さい。
  </ErrorPageBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { SHADOW_CONTACT_URL } from '@/config'
import ErrorPageBase from './ErrorPageBase.vue'
import ExternalLink from '@/components/atoms/ExternalLink.vue'

export default defineComponent({
  name: 'ErrorBadRequest',
  components: {
    ErrorPageBase,
    ExternalLink,
  },
  computed: {
    contactUrl() {
      return SHADOW_CONTACT_URL
    },
  },
})
</script>

<style lang="scss" module>
.link {
  color: $color-text-and-object-accent-primary;
}
</style>
